<template>
    <div class="modal-card has-text-left" style="width: 100%">
        <header class="modal-card-head">
            <p class="modal-card-title">Schimbare parola</p>
        </header>
        <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
            <section class="modal-card-body">
                <div class="subtitle is-size-6 has-text-weight-semibold">
                    Schimbarea parolei este obligatorie la prima accesare a contului. Aceasta actiune va fi solicitata o
                    singura data.
                </div>
                <ValidationProvider rules="required|min:5" ref="password" name="password" v-slot="{ errors, valid }">
                    <b-field label="Parola" :type="{ 'is-danger': errors[0], 'is-success': valid }" :message="errors">
                        <b-input type="password" v-model.trim="password" required> </b-input>
                    </b-field>
                </ValidationProvider>

                <ValidationProvider
                    rules="required|passwordResetConfimed:password"
                    name="passwordConfirm"
                    v-slot="{ errors, valid }"
                >
                    <b-field
                        label="Confirmare parola"
                        :type="{ 'is-danger': errors[0], 'is-success': valid }"
                        :message="errors"
                    >
                        <b-input type="password" v-model.trim="passwordConfirm" required> </b-input>
                    </b-field>
                </ValidationProvider>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="$emit('close')">Inchide</button>
                <button class="button is-success" @click="handleSubmit(save)">Schimba parola</button>
            </footer>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import * as toast from '@/utils/toast';
export default {
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data: () => ({
        password: '',
        passwordConfirm: '',
    }),
    methods: {
        async save() {
            try {
                await this.$store.dispatch('family/ChangePassword', this.password);
                toast.success('Parola a fost schimbata!', 5000, 'is-top');
                return this.$emit('changed');
            } catch (err) {
                console.log(err);
                return false;
            }
        },
    },
};
</script>

<style></style>
